import { memo } from 'react';

import { KnmKindCodesEnum } from 'APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { KNM_OTHER_INFO } from 'CorePackage/MainModule/routes/routes';
import { Section } from 'UIPackage/FormModule/components/Section';

import { ErknmServiceDocument } from './ErknmServiceDocument';
import { ErknmWithVideo } from './ErknmWithVideo';
import { ErknmPresence } from './ErknmPresence';
import { ErknmSelection } from './ErknmSelection';
import { ErknmReturnSelection } from './ErknmReturnSelection';

interface IErknmOtherInfoProps {
  watchOnlyExtended: boolean;
  kindKnmCode: KnmKindCodesEnum | undefined;
  isSelection: boolean | undefined;
  serviceDocumentAttachmentsNumber: number;
  isPresence: boolean | undefined;
  hasActs: boolean;
}

export const ErknmOtherInfo = memo(
  ({
    watchOnlyExtended,
    kindKnmCode,
    serviceDocumentAttachmentsNumber,
    isSelection,
    isPresence,
    hasActs,
  }: IErknmOtherInfoProps) => {
    const isDisabled = watchOnlyExtended || hasActs;

    return (
      <Section title="Иная информация" id={KNM_OTHER_INFO}>
        {kindKnmCode === KnmKindCodesEnum.MZ && (
          <ErknmServiceDocument watchOnly={isDisabled} attachmentsNumber={serviceDocumentAttachmentsNumber} />
        )}

        {kindKnmCode === KnmKindCodesEnum.VK && (
          <>
            <ErknmWithVideo watchOnly={isDisabled} />
            <ErknmPresence watchOnly={isDisabled} isPresence={isPresence} />
            <ErknmSelection watchOnly={isDisabled} isSelection={isSelection} />
            <ErknmReturnSelection watchOnly={isDisabled} />
          </>
        )}
      </Section>
    );
  },
);
